import React, {Component} from 'react';

// Components
import Button from '../../components/Button/Button'

class CallToAction extends Component {

    render () {

        return (
            
            <div className={ `cta ${this.props.classes}` }>
                <div className="container">
                <h3>{this.props.text}</h3>
                { this.props.buttonLink !== '' &&
                    <Button title={this.props.buttonTitle} link={this.props.buttonLink} icon={this.props.buttonIcon} classes={this.props.buttonClasses} />
                }

                </div>
            </div>
        );
    }
}

export default CallToAction;


// WEBPACK FOOTER //
// ./src/containers/CallToAction/CallToAction.js